module.exports = __webpack_public_path__ + "static/fipcsafari4-2dee8d2e047d103b651c26c4b83bba09.jpeg";